/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import React from "react";
import useExecute from "../../../../Basis/Utils/useExecute";
import ErstelleProvisionenCsvExport from "../../../../Cloud/Exporte/Commands/ErstelleProvisionenCsvExport";
import ErstelleCsvExportDialog, { ErstelleCsvExportInput } from "../../../../Cloud/Exporte/Components/ErstelleCsvExportDialog";
import Feld from "../../../../Cloud/Exporte/Queries/Feld";
import { PromiseFindeExportvorlagen } from "../../../../Cloud/Exporte/Queries/FindeExportvorlagen";
import FindeFilterInfosFuerProvisionenCsvExport from "../../../../Cloud/Exporte/Queries/FindeFilterInfosFuerProvisionenCsvExport";
import LadeFelderFuerProvisionenCsvExport from "../../../../Cloud/Exporte/Queries/LadeFelderFuerProvisionenCsvExport";
import UIConstants from "../../../../UIConstants";
import { translationKeys, useTranslation } from "../../Internationalisierung/i18nMandanten";

interface ErstelleProvisionenCsvExportDialogProps {
    isOpen: boolean;
    onAbgebrochen: () => void;
    onExportiert: () => void;
    rechnungId?: string;
    gutschriftId?: string;
}

export default function ErstelleProvisionenCsvExportDialog(props: ErstelleProvisionenCsvExportDialogProps) {
    const { t } = useTranslation();
    const [felder, setFelder] = React.useState<Feld[]>([]);
    new LadeFelderFuerProvisionenCsvExport(setFelder);

    const query = new FindeFilterInfosFuerProvisionenCsvExport();
    function findeFilterInfosFuerCsvExport(suchbegriff: string) {
        return query.execute({
            suchbegriff,
            nimm: UIConstants.nimm,
            ueberspringe: 0,
        });
    }

    const execute = useExecute(new ErstelleProvisionenCsvExport());
    function erstelleCsvExport(input: ErstelleCsvExportInput) {
        return execute({ ...input, rechnungId: props.rechnungId, gutschriftId: props.gutschriftId });
    }

    const promiseFindeExportvorlagen = new PromiseFindeExportvorlagen();
    function findeExportvorlagen(suchbegriff: string) {
        return promiseFindeExportvorlagen.execute({
            fuer: "PROVISIONEN",
            suchbegriff,
            nimm: UIConstants.nimm,
            ueberspringe: 0,
        });
    }

    return (
        <ErstelleCsvExportDialog
            isOpen={props.isOpen}
            erstelleCsvExport={erstelleCsvExport}
            findeFilterInfosFuerCsvExport={findeFilterInfosFuerCsvExport}
            felder={felder}
            onAbgebrochen={props.onAbgebrochen}
            onExportiert={props.onExportiert}
            dialogTitle={t(translationKeys.erstelleProvisionenCsvExportDialog.dialogTitle)}
            findeExportvorlagen={findeExportvorlagen}
        />
    );
}
